/* eslint-disable max-len */

import { Modal } from '@mui/material';
import { useState } from 'react';
import { DemeterMarket } from '../../../Generated/Raven-Demeter';
import { useApplicationSelector } from '../../../Redux/ReduxStore';
import { selectUserMarkets } from '../../../Redux/Slices/UserSlice';
import expanaLogo from '../../Assets/Icons/TermsAndConditions/expanaLogo.svg';
import stoneXLogo from '../../Assets/Icons/TermsAndConditions/stoneXLogo.svg';
import LinkButton, { LinkButtonType } from '../../Components/Form/Buttons/LinkButton';
import styles from './SessionPage.module.scss';
import TermsAndConditions from './TermsAndConditions';

export interface ITrialAccessAgreementProps {
    handleAccept: (accept: boolean) => void;
}

const TrialAccessAgreement: React.FC<ITrialAccessAgreementProps> = (props) => {
    const [generalTermsAccepted, setGeneralTermsAccepted] = useState(false);
    const markets = useApplicationSelector(selectUserMarkets);
    const requiresExpana = markets.includes(DemeterMarket.Dairy);

    const handleAcceptTerms = () => {
        // if (requiresExpana && !generalTermsAccepted) {
        //     setGeneralTermsAccepted(true);
        //     return;
        // }

        props.handleAccept(true);
    };

    return (
        <Modal open>
            <div className={styles.acknowledgements_modal}>
                <div className={styles.acknowledgements_content_container}>
                    <div className={styles.acknowledgements_content_container_header}>
                        <p>StoneX Financial Inc.</p>
                        <p>230 South LaSalle, Suite 10-500</p>
                        <p>Chicago, IL 60604</p>
                        <p>Phone: 312-780-6700</p>
                    </div>
                    <img className={styles.acknowledgements_image} src={generalTermsAccepted ? expanaLogo : stoneXLogo} alt="#" />
                    <div className={styles.acknowledgements_content_container_title}>
                        <h1>We have updated our Terms and Conditions. Please review and Accept.</h1>
                    </div>
                    {/* {!generalTermsAccepted && <TermsAndConditions /> }  */}
                    <TermsAndConditions />
                </div>
                <div className={styles.acknowledgements_footer}>
                    <div className={styles.acknowledgements_button_container}>
                        <LinkButton
                            title="Accept"
                            type={LinkButtonType.Blue}
                            onClick={handleAcceptTerms}
                            track={{ eventCategory: 'Session', eventAction: 'TermsAndConditionsAcceptClicked' }}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default TrialAccessAgreement;
